import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  flex: 1;

  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(14)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};

`;

export const StoreLogo = styled(FastImage)`
  height: ${RFValue(52)}px;
  width: ${RFValue(52)}px;
  background-color: ${({theme}) => theme.colors.shape};
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(14)}px;
`;

export const StoreInfos = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const StoreMeta = styled.View`
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const StoreCategoryPill = styled.View`
  padding: ${RFValue(2)}px ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(12)}px;
  margin-right: ${RFValue(6)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const StoreCategory = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(9)}px;
  text-transform: uppercase;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const StoreName = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-right: ${RFValue(12)}px;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
  line-height: ${RFValue(18)}px;

`;

export const StoreArrow = styled(Feather)`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(18)}px;
  margin-left: ${RFValue(6)}px;
`;
